import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { createElement } from 'react';

import { Breakpoints } from 'utils/const.styles';

const TypographyComponent = ({ tag, innerRef, children, ...props }) =>
	createElement(tag, { ...props, ref: innerRef }, children);

export const Typography = styled(TypographyComponent)`
	display: block;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	${(props) => props.align === 'center' && 'text-wrap: balance;'};

	&.maxlines {
		display: -webkit-box;
		-webkit-line-clamp: ${(props) => props.maxlines ?? 'unset'};
		-webkit-box-orient: vertical;
	}
	&.gutterBottom {
		margin-bottom: var(--margin-2);
	}
	&.noWrap {
		white-space: normal;
	}

	&.link {
		text-decoration: underline;
	}

	&.fullWidth {
		width: 100%;
	}

	${(props) => props.align && `text-align:${props.align};`};
	color: ${(props) => (props.color ? `${props.color}` : 'var(--black)')};

	@media ${Breakpoints.mobile} {
		white-space: normal;
		overflow-wrap: break-word;
	}
`;

export const TooltipContainerCss = css`
	max-height: 30dvh;

	> span {
		overflow: auto;
		max-height: inherit;
	}
`;

export const TooltipPopperCss = css`
	> div {
		margin-top: var(--margin-4);
	}
`;
